<template>
  <div class="publication-content">
    <h1>论文发表</h1>

    <!-- 搜索栏 -->
    <div class="search-bar">
  <div class="filter-row">
    <input type="text" placeholder="搜索..." v-model="searchQuery" class="search-input" />

    <select v-model="selectedGroup" class="filter-select">
      <option value="all">所有组别</option>
      <option value="Computing_Power_Network">算力网络</option>
      <option value="Star_earth_fusion">星地融合</option>
      <option value="Federated_learning">联邦学习</option>
      <option value="Large_scale_model">大规模模型</option>
      <option value="Digital_Twin">数字孪生</option>
    </select>

    <select v-model="selectedYear" class="filter-select">
      <option value="all">所有年份</option>
      <option v-for="year in uniqueYears" :key="year" :value="year">{{ year }}</option>
    </select>
  </div>
</div>

    <!-- 展示筛选后的出版物 -->
    <div v-for="(pub, index) in filteredPublications" :key="index" class="publication-item">
      <h2><a :href="pub.link" target="_blank">{{ pub.title }}</a></h2>
      <p class="authors">{{ pub.authors }}</p>
      <p class="journal">{{ pub.journal }}</p>
      <p class="meta">Posted on {{ pub.date }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "PublicationView",
  data() {
    return {
      searchQuery: "",
      selectedGroup: "all",
      selectedYear: "all",
      publications: []
    };
  },
  computed: {
  uniqueYears() {
    return [...new Set(this.publications.map(pub => pub.year))].sort((a, b) => b - a);
  },
  filteredPublications() {
  return this.publications
    .filter(pub => {
      const matchesSearch = pub.title.toLowerCase().includes(this.searchQuery.toLowerCase());
      const matchesGroup = this.selectedGroup === "all" || pub.group === this.selectedGroup;
      const matchesYear = this.selectedYear === "all" || pub.year === Number(this.selectedYear);
      return matchesSearch && matchesGroup && matchesYear;
    })
    .sort((a, b) => {
      // 首先按 pinned 属性排序
      const pinnedOrder = (b.pinned ? 1 : 0) - (a.pinned ? 1 : 0);
      if (pinnedOrder !== 0) return pinnedOrder;
      // 按日期倒序排序，处理 "YYYY/M/D" 格式
      const dateA = new Date(a.date.replace(/\//g, '-')); // 将 "2019/1/11" 转为 "2019-1-11"
      const dateB = new Date(b.date.replace(/\//g, '-')); // 将 "2019/1/11" 转为 "2019-1-11"
      return dateB - dateA;
    });
}
},
  async mounted() {
    await this.fetchPublications();
  },
  methods: {
    async fetchPublications() {
      try {
        const response = await fetch("/publications.json", {
          headers: { "Accept": "application/json" }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        this.publications = await response.json();
      } catch (error) {
        console.error("获取出版物数据失败:", error);
      }
    }
  }
};
</script>

<style scoped>
.publication-content {
  padding: 1.25rem;
}

a {
  text-decoration: none;
}

.search-bar {
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-bottom: 1.25rem;
}

.filter-row {
  display: flex;
  justify-content: space-between;
  gap: 1.25rem;
  margin-bottom: 0.625rem;
}

.filter-select,
.search-input {
  padding: 0.5rem;
  font-size: 1rem;
  width: 100%;
  max-width: 15.625rem;
  border: 1px solid #ccc;
  border-radius: 0.3125rem;
}

.publication-item {
  margin-bottom: 0.9375rem;
}

.publication-item h2 {
  font-size: 1.2rem;
}

.publication-item .meta {
  font-size: 0.9rem;
  color: #777;
}
</style>
